<div class="modal-header">
  <h4 class="modal-title">{{ MessageHeader}}</h4>
</div>

<div class="modal-body">
  <p>{{ MessageTitle }}</p>


  <input
    type="text"
    class="form-control"
    [(ngModel)]="userInput"
    [placeholder]="MessageTitle"
  />
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="cancel()">{{"Cancel"| localize}}</button>
  <button class="btn btn-primary" (click)="submit()">{{"Submit" | localize}}</button>
</div>
